module.exports.displaySearchBox = function() {
  $('#inputs').hide();
  $('.woosmap-directions-routes').hide();
  $('.woosmap-sidebar-box').show();
  $('.decathlon-woosmap-sidebar').show();
  $('#my-direction').hide();
};


module.exports.displayTravelBox = function(state) {
  return function() {
    $('.woosmap-form-label-local.geolocation-button').click();
    var selectedStore = state.mapView.get('selectedStore');
    state.originDestinationInput.set('selectedStore', selectedStore);
    $('.woosmap-sidebar-box').hide();
    $('.woosmap-directions-routes').show();
    $('.decathlon-woosmap-sidebar').hide();
    $('#my-direction').show();
    $('#inputs').show();
    $(window).scrollTo($('body'), 1200);
  };
};



// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator-utils.js